import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { Consulta } from '../../services/mockData';
import './Consultation.css';

interface ConsultationDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  consulta: Consulta | null;
}

function formatDateTime(iso: string) {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function formatDate(iso: string) {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

function formatTime(iso: string) {
  const d = new Date(iso);
  if (isNaN(d.getTime())) return '-';
  return d.toLocaleTimeString('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

export const ConsultationDetailModal: React.FC<ConsultationDetailModalProps> = ({
  isOpen,
  onClose,
  consulta,
}) => {
  if (!consulta) return null;

  const statusLabel =
    consulta.status === 'confirmada'
      ? 'Confirmada'
      : consulta.status === 'aguardando'
        ? 'Aguardando confirmação'
        : 'Em aberto';

  const statusClass =
    consulta.status === 'confirmada'
      ? 'ns-badge ns-badge-success'
      : consulta.status === 'aguardando'
        ? 'ns-badge ns-badge-warning'
        : 'ns-badge ns-badge-neutral';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Detalhes da Consulta"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Fechar
        </Button>
      }
    >
      <div className="ns-consultation-detail">
        <div className="ns-consultation-detail-field">
          <strong>Paciente:</strong>
          <span>{consulta.pacienteNome}</span>
        </div>
        <div className="ns-consultation-detail-field">
          <strong>Data:</strong>
          <span>{formatDate(consulta.dataIso)}</span>
        </div>
        <div className="ns-consultation-detail-field">
          <strong>Horário:</strong>
          <span>{formatTime(consulta.dataIso)}</span>
        </div>
        <div className="ns-consultation-detail-field">
          <strong>Tipo:</strong>
          <span>
            {consulta.tipo === 'primeira' ? 'Primeira consulta' : 'Retorno'}
          </span>
        </div>
        <div className="ns-consultation-detail-field">
          <strong>Status:</strong>
          <span className={statusClass}>{statusLabel}</span>
        </div>
        {consulta.notes && (
          <div className="ns-consultation-detail-field">
            <strong>Observações:</strong>
            <span style={{ whiteSpace: 'pre-wrap' }}>{consulta.notes}</span>
          </div>
        )}
      </div>
    </Modal>
  );
};

















